import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Flex, Box, Text, Card, Button } from 'rebass/styled-components'
import styled from 'styled-components';
import { CURRENT_USER } from '../graphql/queries';
import { ICurrentUserOutput, IUser } from '../graphql/types/queries/user'
import withSession from '../lib/withSession';
import { Constants } from '../utils/Constants';
import { formatPhoneNumber } from '../utils/formatPhoneNumber';

const Divider = styled(Box)`
  width: 100%;
  height: 1px;
  min-height: 1px;
  background-color: #C9C9C9;
  margin-top: 25px;
  margin-bottom: 25px;
`

const AvatarImg = styled(Flex)`
  background: #FFE3D8;
  border-radius: 50%;
  border: 10px solid #f2f5f9;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  width: 108px;
  height: 108px;
  min-width: 108px;
  margin-top: -80px;
  & > img {
    width: 108px;
  }
`;

const Container = styled(Flex)`
  padding: ${() => `${Constants.OUTLETS_PADDING_MOBILE}px`};
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP_MOBILE}px`};
  width: 100%;
  padding-bottom: 100px;
  
  @media screen and (min-width: 68.8125em) {
    padding: ${() => `${Constants.OUTLETS_PADDING}px`};
    padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP}px`};
    min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
  }
`

interface IProfileProps {
  session: IUser
}

const Settings: React.FC<IProfileProps> = ({ session }) => {
  const navigate = useNavigate()
  const { data, client } = useQuery<ICurrentUserOutput>(CURRENT_USER)

  const exitImpersonationMode = async () => {
    toast.success(<Flex flexDirection={'column'}>
      <Text fontWeight={400}>Exit Impersonation</Text>
    </Flex>, {
      autoClose: 5000,
      position: toast.POSITION.TOP_RIGHT,
    })
    const initialToken = localStorage.getItem('initialToken');

    // console.log('Initial Tok', initialToken);
    localStorage.setItem('token', initialToken || '');
    localStorage.setItem('initialToken', '');
    await client.clearStore()
    await client.cache.reset()
    navigate('/impersonate')
  }
  const initTok = localStorage.getItem('initialToken');
  return (
    <Container flexDirection={'column'} style={{ minHeight: '100%' }}>
      <Card flex='initial' justifyContent={'center'} style={{ borderRadius: '20px' }} p={'38px'} alignItems='center' mt={5} display={'flex'} flexDirection='column'>
        <AvatarImg>
          <img
            alt=""
            src={session.picture}
          />
        </AvatarImg>

        <Text mt={3} fontWeight={600} fontSize='24px'>{session.patientFacingName}</Text>
        <Text fontWeight={300} mt={'10px'} fontSize='12px'>{`${session.email}`}</Text>
        <Text fontWeight={300} mt={2} fontSize='12px'>{formatPhoneNumber(session.phone)}</Text>

        <Button variant={'outline'} mt={'24px'} onClick={() => {
          navigate('/profile')
        }}>

          <Flex alignItems={'center'} justifyContent='center'>
            <Text fontWeight={300} textAlign='center' fontSize='14px' ml={2}>Edit</Text>
          </Flex>
        </Button>
      </Card>
      <Flex flex={1}>
      </Flex>
      {
        !!initTok && (
          <Card mt={4} style={{ borderRadius: '20px', backgroundColor: 'white', height: 'fit-content', width: '100%', flex: 'initial', display: 'flex', border: '1px solid #344f79', cursor: 'pointer' }} p={2} alignItems='center' justifyContent={'center'} onClick={exitImpersonationMode}>
            <Text>Exit impersonating mode</Text>
          </Card>)
      }
      <Card mt={4} style={{ borderRadius: '20px', backgroundColor: '#F6A293', flex: 'initial', display: 'flex', cursor: 'pointer' }} p={2} alignItems='center' justifyContent={'center'} onClick={() => navigate('/logout')}>
        <Text color={'white'}>Log out</Text>
      </Card>

      <Flex height={'200px'} width='100%'></Flex>
    </Container>);
}

export default withSession(Settings)